// extracted by mini-css-extract-plugin
module.exports = {"comp":"JB_comp__KhoxU"};